export const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
export const baseUrlB2b = process.env.NEXT_PUBLIC_BASE_URL_B2B;
export const baseUrlCoupon = process.env.NEXT_PUBLIC_COUPON;
export const moodleUrl = process.env.NEXT_PUBLIC_MOODLE_URL;
